import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { collection, query, where, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';
import styles from './AdminDeleteEvents.module.css';

function AdminDeleteEvents() {
  const { currentUser } = useAuth();
  const [hairstylistId, setHairstylistId] = useState('Airt3I3RoM2JQE7vM6LT');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  // Vérifier si l'utilisateur est admin
  const displayName = currentUser?.displayName || currentUser?.email?.split('@')[0] || '';
  const isAdmin = currentUser && displayName?.toLowerCase() === 'admin';

  const handleDelete = async () => {
    if (!isAdmin) {
      setError('Accès refusé. Vous devez être admin.');
      return;
    }

    if (!hairstylistId.trim()) {
      setError('Veuillez entrer un hairstylistId');
      return;
    }

    setLoading(true);
    setError(null);
    setResult(null);

    try {
      // Récupérer tous les événements pour ce hairstylistId
      const eventsRef = collection(db, 'hairstylistStats');
      const q = query(eventsRef, where('hairstylistId', '==', hairstylistId.trim()));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        setResult({
          success: true,
          message: 'Aucun événement trouvé pour ce hairstylistId.',
          count: 0,
        });
        setLoading(false);
        return;
      }

      // Supprimer tous les documents
      const deletePromises = querySnapshot.docs.map((docSnapshot) =>
        deleteDoc(doc(db, 'hairstylistStats', docSnapshot.id))
      );

      await Promise.all(deletePromises);

      setResult({
        success: true,
        message: `${querySnapshot.size} événement(s) supprimé(s) avec succès !`,
        count: querySnapshot.size,
      });
    } catch (err) {
      console.error('Erreur lors de la suppression:', err);
      setError(`Erreur: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  if (!isAdmin) {
    return (
      <div className={styles.page}>
        <div className={styles.container}>
          <h1>Accès refusé</h1>
          <p>Vous devez être admin pour accéder à cette page.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <h1>Supprimer les événements d'un hairstylist</h1>
        <p className={styles.warning}>
          ⚠️ Cette action est irréversible. Tous les événements pour ce hairstylistId seront supprimés.
        </p>

        <div className={styles.form}>
          <label htmlFor="hairstylistId">Hairstylist ID:</label>
          <input
            id="hairstylistId"
            type="text"
            value={hairstylistId}
            onChange={(e) => setHairstylistId(e.target.value)}
            placeholder="Airt3I3RoM2JQE7vM6LT"
            className={styles.input}
          />

          <button
            type="button"
            onClick={handleDelete}
            disabled={loading}
            className={styles.deleteButton}
          >
            {loading ? 'Suppression en cours...' : 'Supprimer tous les événements'}
          </button>
        </div>

        {error && (
          <div className={styles.error}>
            {error}
          </div>
        )}

        {result && (
          <div className={result.success ? styles.success : styles.error}>
            {result.message}
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminDeleteEvents;

